import { IconProps } from "@models/types";
export function LeftArrow({ className, width, height }: IconProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <g id="Group_901">
        <path d="M1.78,9.4H19.31c.31,0,.57,.27,.57,.6s-.25,.6-.57,.6H1.78c-.31,0-.57-.27-.57-.6s.25-.6,.57-.6Z" />
      </g>
      <path d="M.33,10.41c-.27-.18-.27-.64,0-.82l1.25-.83,1.25-.83c.27-.18,.62,.05,.62,.41v3.3c0,.36-.34,.59-.62,.41l-1.25-.83-1.25-.83Z" />
    </svg>
  );
}
